import { selectPermissions } from 'app/containers/Authorization/slice/selectors';
import { PermissionsEnum } from 'app/containers/User/slice/types';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import NoPermissionsCard from '../NoPermissionsCard/NoPermissionsCard';

interface IProps {
  requiredEditPermissions: PermissionsEnum[];
  show403Card?: boolean;
}

const PermissionsWrapper: FC<IProps> = ({
  requiredEditPermissions,
  show403Card,
  children,
}) => {
  const permissions = useSelector(selectPermissions);

  const isVisible = useMemo(() => {
    let allowed = true;

    requiredEditPermissions.forEach(reqPermission => {
      if (permissions[reqPermission] !== 2) {
        allowed = false;
      }
    });

    return allowed;
  }, [requiredEditPermissions, permissions]);

  if (!isVisible) {
    if (show403Card) {
      return <NoPermissionsCard />;
    }
    return null;
  }

  return <>{children}</>;
};

export default PermissionsWrapper;
